export const environment = {
    firebase: {
        apiKey: "AIzaSyDxAylE8ymlCEMo1FqM3FQABqSilAA8Jv4",
        authDomain: "mobitrix-android.firebaseapp.com",
        databaseURL: "https://mobitrix-android.firebaseio.com",
        projectId: "mobitrix-android",
        storageBucket: "mobitrix-android.firebasestorage.app",
        messagingSenderId: "914093533371",
        appId: "1:914093533371:web:f2a1f1c6f080b7e21c619e",
        measurementId: "G-BE68PEMSLH",
        vapId: "BC9iXdc2B8R6GNGF3SOB8VpOzeAhXcsd-3iu4XOodmzTTW37VqAmOLOatzqT7J_I9-_tcNK2yzqHQMX0qw41Yws"
    },
    "serviceWorkerScript": "src/firebase-messaging-sw.js",
    "production": true,
    googleMapsApiKey: "AIzaSyAEU3XtsD3WDUIhG9c9NyTsR7RsIX5HU2E"
};
